<template>
  <div style="font-size: 14px; line-height: 22px; margin-bottom: 7px; color: rgba(0, 0, 0, 0.65);">
    <p class="item-title" style="margin-right: 8px; display: inline-block; color: rgba(0, 0, 0, 0.85);">{{title}}： </p>
    <template id="content">
      {{ content }}
      <slot name="content"></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: "DescriptionItem",
  props: ['title', 'content']
}
</script>

<style scoped>
  .item-title{
    min-width: 100px;
    width: max-content;
    text-align: right;
  }
</style>